import { Trans } from "@lingui/react/macro";
import { getLegalPages } from "@/utils";
import { Divider, Link } from "@heroui/react";

const LegalPages = ({ language }) => {
  const { termsAndConditionsUrl, privacyPolicyUrl } = getLegalPages({
    language,
  });

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
      <LegalPageLink href={"https://lime-booking.com/"}>
        © Lime Booking
      </LegalPageLink>
      <Divider orientation="vertical" />
      <LegalPageLink href={privacyPolicyUrl}>
        <Trans>Politika zasebnosti</Trans>
      </LegalPageLink>
      <Divider orientation="vertical" />
      <LegalPageLink href={termsAndConditionsUrl}>
        <Trans>Splošni pogoji</Trans>
      </LegalPageLink>
    </div>
  );
};

const LegalPageLink = ({ href, children }) => {
  return (
    <Link
      href={href}
      className="whitespace-nowrap text-default-400 text-xs"
      target="_blank"
    >
      {children}
    </Link>
  );
};

export default LegalPages;
